import "../front/globals.js"

import "@front/lib/accounting.js"
import "@front/lib/bot_map_lazyload_guard.js"
import "@front/lib/control_offset.js"
import "@front/lib/debounce.js"
import "@front/lib/drawer.js"
import "@front/lib/fullscreen_overlay.js"
import "@front/lib/is_mobile.js"
import "@front/lib/native_app_version.js"
import "@front/lib/native_back.js"
import "@front/lib/prevent_scroll.js"
import "@front/lib/rails_request.js"
import "@front/lib/throttle.js"

import "@front/lib.js"

accounting.settings = $.extend(
  true,
  accounting.settings,
  window.accountingSettings,
)
